import { render, staticRenderFns } from "./LinkedObjectPublic.vue?vue&type=template&id=716d7b85&scoped=true&"
import script from "./LinkedObjectPublic.vue?vue&type=script&lang=js&"
export * from "./LinkedObjectPublic.vue?vue&type=script&lang=js&"
import style0 from "./LinkedObjectPublic.vue?vue&type=style&index=0&id=716d7b85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716d7b85",
  null
  
)

export default component.exports